export const REDEMPTION_OPTIONS = [
  { label: '1 Year', value: '1' },
  { label: '2 Years', value: '2' },
  { label: '3 Years', value: '3' },
  { label: '5 Years', value: '5' },
  { label: '7 Years', value: '7' },
  { label: '10+ Years', value: '10+' },
];

export const COUPON_OPTIONS = [
  { label: '6%+', value: '6' },
  { label: '7%+', value: '7' },
  { label: '8%+', value: '8' },
  { label: '9%+', value: '9' },
  { label: '10%+', value: '10' },
  { label: '11%+', value: '11' },
  { label: '12%+', value: '12' },
];

export const RATING_OPTIONS = [
  'AAA', 'AAA(SO)', 'AA+', 'AA+(SO)', 'AA', 'AA(SO)', 'AA-', 'AA-(SO)',
  'A+', 'A+(SO)', 'A', 'A(SO)', 'A-', 'A-(SO)',
  'BBB+', 'BBB+(SO)', 'BBB', 'BBB(SO)', 'BBB-', 'BBB-(SO)', 'Below BBB-',
].map((r) => ({ label: r, value: r }));
